var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M860.497625,133.621607 C1029.57042,337.617506 1059.42862,642.904372 855.287749,811.857092 C620.319064,1006.32147 269.155747,1018.89418 74.5517764,784.092362 C-100.824363,572.488861 61.0116642,284.257671 272.765083,109.004689 C449.687484,-37.42332 713.966945,-43.1765394 860.497625,133.621607 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264.0053, -125.4958)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    fill: "#FEEBE6",
    x: 0,
    y: 0,
    width: 1646.93341,
    height: 1191.44027
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#111411",
    strokeWidth: 27.84,
    fill: "#FDB29F",
    x: 501.038895,
    y: 380.148257,
    width: 561.349133,
    height: 788.11224,
    rx: 102.08
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    fill: "#111411",
    x: 700.526604,
    y: 445.051618,
    width: 157.734467,
    height: 46.3595435,
    rx: 23.1797718
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#111411",
    strokeWidth: 9.28,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 83.938369,
    y: 438.083273,
    width: 666.437402,
    height: 222.525809,
    rx: 41.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.845421,526.833983 C173.13721,526.833983 174.997549,528.693 174.997549,530.987798 L174.997549,553.592711 C174.997549,555.887509 173.13721,557.746526 170.845421,557.746526 L158.732342,557.746526 L158.732342,575.506867 L151.360575,575.506867 L151.360575,526.833983 L170.845421,526.833983 Z M167.277839,533.041526 L158.500379,533.041526 L158.500379,551.446264 L167.277839,551.446264 L167.277839,533.041526 Z M178.787815,526.833983 L186.127107,526.833983 L186.127107,569.058255 L198.133484,569.058255 L198.133484,575.506867 L178.787815,575.506867 L178.787815,526.833983 Z M201.612921,575.506867 L208.799117,575.506867 L208.799117,546.105645 L219.724549,575.506867 L226.405068,575.506867 L226.405068,526.833983 L219.362687,526.833983 L219.362687,555.433185 L208.390864,526.833983 L201.612921,526.833983 L201.612921,575.506867 Z",
    id: "Shape",
    fill: "#111411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.180395,551.168107 C263.180395,592.312202 229.805637,625.663258 188.636941,625.663258 C169.045392,625.663258 151.221398,618.115924 137.916031,605.765741 L146.345547,597.319033 C157.489023,607.522768 172.33462,613.744219 188.636941,613.744219 C223.217903,613.744219 251.252885,585.729147 251.252885,551.168107 C251.252885,534.821732 244.980621,519.935683 234.704684,508.786212 L243.1342,500.34414 C255.572026,513.653964 263.180395,531.520933 263.180395,551.168107 Z",
    id: "Path",
    fill: "#FB6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.636941,476.677593 C208.284161,476.677593 226.159187,484.271286 239.478471,496.691008 L231.016481,505.105265 C219.863726,494.85517 204.981015,488.596631 188.636941,488.596631 C154.05134,488.596631 126.016358,516.611703 126.016358,551.168107 C126.016358,567.398583 132.195837,582.178006 142.332597,593.29966 L133.870606,601.713917 C121.590514,588.431908 114.087921,570.676203 114.087921,551.168107 C114.087921,510.028648 147.463606,476.677593 188.636941,476.677593 Z",
    id: "Path",
    fill: "#55CE00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#111411",
    strokeWidth: 9.28,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 283.426077,
    y: 695.06813,
    width: 656.351675,
    height: 222.525809,
    rx: 41.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.964551,784.806299 C371.228505,784.806299 373.061008,786.637501 373.061008,788.89521 L373.061008,811.161699 C373.061008,813.424045 371.228505,815.255247 368.964551,815.255247 L357.032402,815.255247 L357.032402,832.751338 L349.776617,832.751338 L349.776617,784.806299 L368.964551,784.806299 Z M365.452639,790.916486 L356.805079,790.916486 L356.805079,809.047704 L365.452639,809.047704 L365.452639,790.916486 Z M376.790964,784.806299 L384.023553,784.806299 L384.023553,826.400081 L395.848999,826.400081 L395.848999,832.751338 L376.790964,832.751338 L376.790964,784.806299 Z M399.277404,832.751338 L406.356898,832.751338 L406.356898,803.790532 L417.119956,832.751338 L423.698411,832.751338 L423.698411,784.806299 L416.758095,784.806299 L416.758095,812.974357 L405.953284,784.806299 L399.277404,784.806299 L399.277404,832.751338 Z",
    id: "Shape",
    fill: "#111411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.926307,808.778818 C459.926307,849.306331 427.047949,882.16134 386.491634,882.16134 C367.192358,882.16134 349.63744,874.720633 336.531561,862.560525 L344.831178,854.238987 C355.807641,864.2851 370.435193,870.418468 386.491634,870.418468 C420.557639,870.418468 448.175089,842.820631 448.175089,808.778818 C448.175089,792.673513 441.995609,778.009989 431.872768,767.027414 L440.177024,758.710511 C452.42928,771.82099 459.926307,789.423709 459.926307,808.778818 Z",
    id: "Path",
    fill: "#FB6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.491634,735.396297 C405.846581,735.396297 423.45717,742.878727 436.576966,755.108375 L428.240236,763.397461 C417.254494,753.300353 402.594467,747.134533 386.491634,747.134533 C352.425628,747.134533 324.808179,774.73237 324.808179,808.778818 C324.808179,824.763589 330.894873,839.325122 340.878537,850.275246 L332.546446,858.564332 C320.447285,845.486305 313.056961,827.994849 313.056961,808.778818 C313.056961,768.251306 345.935319,735.396297 386.491634,735.396297 Z",
    id: "Path",
    fill: "#55CE00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEEBE6",
    fillRule: "nonzero",
    x: 311.261572,
    y: 500.358047,
    width: 371.139923,
    height: 27.8157261,
    rx: 13.9078631
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEEBE6",
    fillRule: "nonzero",
    x: 515.388529,
    y: 759.971491,
    width: 296.911938,
    height: 27.8157261,
    rx: 13.9078631
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEEBE6",
    fillRule: "nonzero",
    x: 311.261572,
    y: 569.897363,
    width: 278.354942,
    height: 27.8157261,
    rx: 13.9078631
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEEBE6",
    fillRule: "nonzero",
    x: 515.388529,
    y: 829.510806,
    width: 329.386681,
    height: 27.8157261,
    rx: 13.9078631
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardNotifications);
export default __webpack_public_path__ + "static/media/onboard_notifications.19c20e36a0c6f0fb32e345731d589366.svg";
export { ForwardRef as ReactComponent };